module.exports = __webpack_public_path__ + "static/media/title1.a6fb243d.png";